<template>
  <main-layout :title="$t('Delete your account')" :infos="infos">
    <template v-slot:body>
      <v-card outlined rounded class="pa-10">
        <v-card-text class="pa-0">
          <h2>{{$t('Delete your account from Bookaweb')}}</h2>
          <p class="text-body-1 font-weight-medium my-6">
              {{$t('delete_account_page_subtitle')}}
          </p>
        </v-card-text>
        <v-card-actions class="pa-0">
          <v-btn color="red white--text" @click="showDeleteAccountModal = true">
            {{$t('Delete your account')}}
          </v-btn>
        </v-card-actions>
      </v-card>

      <modal
        :show="showDeleteAccountModal"
        @close="showDeleteAccountModal = false"
        @save="confirmDeleteAccountModal"
        save-text="Submit"
        :title="$t('delete_account_modal_title')"
        :description="$t('delete_account_modal_description')"
        hide-top-close-button
        max-width="400"
      />

      <modal
        :show="showConfirmDeleteAccountModal"
        @close="redirectToDashboard"
        @save="redirectToDashboard"
        save-text="OK"
        :title="$t('delete_account_confirm_modal_title')"
        :description="$t('delete_account_confirm_modal_description')"
        hide-top-close-button
        max-width="400"
        :hideActionsCancel="true"
      />

      <modal
        v-if="showHasActiveSubscriptionModal"
        :show="showHasActiveSubscriptionModal"
        :title="$t('hasActiveSubscriptionErrorModal.title')"
        @close="showHasActiveSubscriptionModal = false"
        :sticky-header="true"
        hide-top-close-button
        max-width="450"
        primary-button-class="d-none"
        close-text="Back"
      >
        <div class="pa-4 text-center font-weight-medium">
          <p>
            {{ $t('hasActiveSubscriptionErrorModal.descriptionAccount') }}
            <br><br>
            {{ $t('hasActiveSubscriptionErrorModal.cancelSubscription') }}:
          </p>
          <v-btn
            :to="{ name: 'my-subscriptions' }"
            outlined
            class="text-capitalize"
          >
            {{ $t('My Subscriptions') }}
          </v-btn>
        </div>
      </modal>

    </template>
  </main-layout>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      infos: [
        {
          title: 'Infos.DeleteAccount.title',
          description: 'Infos.DeleteAccount.description',
          icon: 'green-energy',
        },
      ],
      showDeleteAccountModal: false,
      showConfirmDeleteAccountModal: false,
      showHasActiveSubscriptionModal: false,
    };
  },
  methods: {
    confirmDeleteAccountModal() {
      this.$store.dispatch('loading', true);
      axios
        .post('/email/request-delete-account')
        .then(() => {
          this.$store.dispatch('message', this.$t('Account deletion request sent'));
          this.$store.dispatch('loading', false);
          this.showDeleteAccountModal = false;
          this.showConfirmDeleteAccountModal = true;
        })
        .catch((error) => {
          this.$store.dispatch('loading', false);
          if (error.response && error.response.data && error.response.data.has_active_subscription) {
            this.showHasActiveSubscriptionModal = true;
            this.showDeleteAccountModal = false;
          } else {
            this.$store.dispatch('setErrors', { message: [error.response.data.message] });
          }
        });
    },
    redirectToDashboard() {
      this.$router.push({ name: 'Dashboard' });
    },
  },
};
</script>
